export default __webpack_public_path__ + "53e63517dbb0020e80a0bee3fceae07a.glb";